/**
 * #6248: the reload-loop guard for the account-load hold.
 *
 * The hold reloads the app on its own when the connection comes back or the background sync
 * succeeds, because a fresh start-up then reads the documents again. If the reason the documents
 * could not be read does not go away (this device's store cannot answer, say), every start-up
 * would hold, see the sync succeed straight away, and reload again: a loop the person cannot
 * stop. So an AUTOMATIC reload is allowed at most once per `ACCOUNT_LOAD_AUTO_RELOAD_MIN_GAP_MS`
 * in a tab. After that the hold stays up and waits for the person to tap Retry, which always
 * reloads. The time of the last automatic reload is kept in sessionStorage so it survives the
 * reload itself; see app.component.ts, `gateUnreadAccountDocumentsBoot`.
 */

/** the shortest time between two automatic reloads from the account-load hold */
export const ACCOUNT_LOAD_AUTO_RELOAD_MIN_GAP_MS = 2 * 60_000;

/** the sessionStorage key holding when the hold last reloaded on its own, in epoch ms */
export const ACCOUNT_LOAD_AUTO_RELOAD_KEY = 'cs_accountLoadHoldAutoReload_ms';

/**
 * May the hold reload the app on its own now? `lastAutoReloadMs` is what sessionStorage held:
 * null when there was nothing (or nothing readable), which allows the reload.
 */
export function mayAutoReloadAccountLoadHold(lastAutoReloadMs: number | null, nowMs: number): boolean {
  // if there is no earlier automatic reload in this tab, or it was long enough ago, allow it
  if (lastAutoReloadMs == null || !Number.isFinite(lastAutoReloadMs)) return true;
  return nowMs - lastAutoReloadMs >= ACCOUNT_LOAD_AUTO_RELOAD_MIN_GAP_MS;
}
